export const QUERY_KEYS = {
  GLOBAL: {
    FETCH_ENUM: "GLOBAL_FETCH_ENUM",
    MASTER_REGION: "MASTER_REGION",
    MASTER_NATIONALITY: "MASTER_NATIONALITY",
    MASTER_LIVING_RELATIONSHIP: "MASTER_LIVING_RELATIONSHIP",
    MASTER_MAIN_OCCUPATION: "MASTER_MAIN_OCCUPATION",
    MASTER_MAIN_INDUSTRY: "MASTER_MAIN_INDUSTRY",
    MASTER_LOCAL_GOVERNMENT_COUNTER: "MASTER_LOCAL_GOVERNMENT_COUNTER",
    MASTER_LANGUAGE_TEST: "MASTER_LANGUAGE_TEST",
    MASTER_SUPPORT_LANGUAGE: "MASTER_SUPPORT_LANGUAGE",
    MASTER_SKILL_TEST: "MASTER_SKILL_TEST",
    MASTER_SPECIFIC_INDUSTRY: "MASTER_SPECIFIC_INDUSTRY",
    MASTER_SPECIFIC_SKILL_CERTIFICATE: "MASTER_SPECIFIC_SKILL_CERTIFICATE",
    MASTER_MAJOR: "MASTER_MAJOR",
    MASTER_COMPANY_SPECIFIC_INDUSTRY: "MASTER_COMPANY_SPECIFIC_INDUSTRY",
    MASTER_RESIDENCE_STATUS: "MASTER_RESIDENCE_STATUS",
    MASTER_BUSINESS_CLASSIFICATION: "MASTER_BUSINESS_CLASSIFICATION",
    FETCH_MAINTENANCE: "GLOBAL_FETCH_MAINTENANCE",
    PROVINCES_MUNICIPALITIES: "PROVINCES_MUNICIPALITIES",
    MASTER_ATTACHMENT_DOCUMENT_TYPE: "MASTER_ATTACHMENT_DOCUMENT_TYPE",
  },
  FILE: {
    FETCH_DETAIL: "FILE_FETCH_DETAIL",
    FETCH_INFO: "FILE_FETCH_INFO",
    FETCH_SIGNED_URL: "FILE_FETCH_SIGNED_URL",
    FETCH_COMPANY_SIGNED_URL: "FETCH_COMPANY_SIGNED_URL",
  },
  USER: {
    FETCH_ME: "USER_FETCH_ME",
  },
  USER_SETTING: {
    FETCH_DETAIL: "USER_SETTING_FETCH_DETAIL",
  },
  USER_PREFERENCE: {
    LANGUAGE: "USER_PREFERENCE_LANGUAGE",
    STUDY_SETTINGS: "USER_PREFERENCE_STUDY_SETTINGS",
  },
  VOCABULARY: {
    CATEGORIES: "VOCABULARY_CATEGORIES",
    WORDS: "VOCABULARY_WORDS",
    PRACTICE_SESSION: "VOCABULARY_PRACTICE_SESSION",
    QUIZ_SESSION: "VOCABULARY_QUIZ_SESSION",
    QUIZ_RESULT: "VOCABULARY_QUIZ_RESULT",
  },
  STUDY: {
    PAGE_DATA: "STUDY_PAGE_DATA",
    DIAGNOSIS_QUIZ: "STUDY_DIAGNOSIS_QUIZ",
    DIAGNOSIS_QUIZ_METADATA: "STUDY_DIAGNOSIS_QUIZ_METADATA",
    WORD_PRACTICE: "STUDY_WORD_PRACTICE",
    WORD_QUIZ: "STUDY_WORD_QUIZ",
    LEVEL_PRACTICE: "STUDY_LEVEL_PRACTICE",
    TEXT_EXPLANATION: "STUDY_TEXT_EXPLANATION",
    SUBJECT_LEVELS: "STUDY_SUBJECT_LEVELS",
    SUBJECT_QUIZ_RESULT: "STUDY_SUBJECT_QUIZ_RESULT",
    SUBJECT_QUIZ_PRACTICE_RESULT: "STUDY_SUBJECT_QUIZ_PRACTICE_RESULT",
    VOCABULARY_QUIZ_RESULT: "STUDY_VOCABULARY_QUIZ_RESULT",
    RECOMMENDATION: "STUDY_RECOMMENDATION",
    CURRICULUM_PROGRESS: "STUDY_CURRICULUM_PROGRESS",
    BOOST_MESSAGE: "STUDY_BOOST_MESSAGE",
  },
  STUDY_TIME: {
    WEEKLY: "STUDY_TIME_WEEKLY",
  },
  MOCK_EXAM: {
    LIST: "MOCK_EXAM_LIST",
    DETAIL: "MOCK_EXAM_DETAIL",
    RESULT: "MOCK_EXAM_RESULT",
  },
  NOTIFICATION: {
    LIST: "NOTIFICATION_LIST",
    UNREAD_COUNT: "NOTIFICATION_UNREAD_COUNT",
  },
} as const;
